module.exports = __webpack_public_path__ + "assets/img/zfb.1963585a.png";